<template lang="pug">
.container.grid-lg
  load-manager(:status="status")
    .card.mt-2(v-if="current")
      .card-body
        .h4 {{ current.entity_label  }}
        .columns.mt-2
          .column
            span Usuário:&nbsp;
            span(v-if="current && current.user") {{ current.user.login | cpfCnpj }} -&nbsp;
            | {{ current && current.user ? current.user.nome : "Sem Usuário - Rotina Automática" }}
        .columns.mt-2
          .column
            span Ação:&nbsp;
            span {{ current.action }}
          .column.col-auto
            span Realizado em:&nbsp;
            span {{ current.time | date }}
        .divider
        div(v-for="tag in tags")
          small {{ tag.titulo }}: {{ tag.descricao }}
    .mt-2
      table.table.table-striped.table-hover.table-sm(
        v-if="current && current.fields"
      )
        thead
          tr
            th Campo
            th Valor anterior
            th Valor novo
        tbody
          tr(v-for="f in current.fields", :key="`${f.log_id}-${f.field}`")
            td {{ f.field }}
            td {{ f.old_value }}
            td {{ f.new_value }}
</template>

<script>
export default {
  vuex: {
    logs: {
      state: ["current", "status"],
      actions: ["fetchOne"],
    },
  },

  computed: {
    tags() {
      if (!this.current) return []
      return this.current.tags || []
    },
  },

  created() {
    this.fetchOne(this.$route.params)
  },
}
</script>
